// Port of api/fuel/app/classes/controller/api/monty/listing/edition/delete.php
import DB from 'offline/db'
import ListingEdition from 'offline/model/listing/edition'
import {
	LIST_TYPE_AUTOMATED,
	currentEdition,
	currentUserId,
	loadListingEdition,
	loadOwnedListing,
	persist,
	recountListing,
	unauthorised
} from '../shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)
	var edition = null
	var fallback = null
	var rows = []

	if (!userId) return unauthorised()
	if (!listing || listing.get_type() === LIST_TYPE_AUTOMATED) return unauthorised()

	edition = loadListingEdition(listing, params.edition) || currentEdition(listing)
	if (!edition) return Promise.reject({ error: 120, offline: true })
	if ((parseInt(listing.get_count_editions(), 10) || 0) <= 1) return unauthorised()

	DB.run('DELETE FROM list_comment WHERE list_edition_id = ?', [edition.get_id()])
	DB.run('DELETE FROM list_edition WHERE list_edition_id = ?', [edition.get_id()])

	rows = DB.query('SELECT list_edition_id FROM list_edition WHERE list_id = ? ORDER BY list_edition_date DESC, list_edition_id DESC LIMIT 1', [
		listing.get_id()
	])
	if (rows.length) {
		DB.run('UPDATE list_edition SET list_edition_current = 1 WHERE list_edition_id = ?', [rows[0].list_edition_id])
		fallback = ListingEdition.with_id(rows[0].list_edition_id)
	}

	recountListing(listing.get_id())
	return persist(fallback ? fallback.to_array() : {})
}
